const configData = {
    debug: false,
};
export const getConfig = () => {
    return configData;
};
export const config = ({ debug }) => {
    configData.debug = debug;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZmlnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vbGliL2NvbmZpZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLFVBQVUsR0FBRztJQUNqQixLQUFLLEVBQUUsS0FBSztDQUNiLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxTQUFTLEdBQUcsR0FBRyxFQUFFO0lBQzVCLE9BQU8sVUFBVSxDQUFDO0FBQ3BCLENBQUMsQ0FBQTtBQUVELE1BQU0sQ0FBQyxNQUFNLE1BQU0sR0FBRyxDQUFDLEVBQUMsS0FBSyxFQUFtQixFQUFFLEVBQUU7SUFDbEQsVUFBVSxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUM7QUFDM0IsQ0FBQyxDQUFDIn0=